import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card,Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";

const modeloDatos = {
    reporteID: 0, moduloID: 0, nombreModulo: '', nombreBoton: '', htmLcode: '', scriptcode: ''
}

const SecuenciaNumerica = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [interativo, Setinterativo] = useState(false);
    const [L_Modulos, SetL_Modulos] = useState([]);


    const handleChange = (e) => {
        let value = e.target.value //e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Administracion/Reporteria/99");
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
        }
    }

    const GetModulos = async () => {

        let response = await fetch(Api + "Administracion/GetModulos");
        if (response.ok) {
            let data = await response.json()
            SetL_Modulos(data)

        }
    }
    useEffect(() => {
        obtenerDatos();
        GetModulos()
    },[])


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.reporteID == 0) {
            response = await fetch(Api + "Administracion/GuardarReporteria", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            response = await fetch(Api + "Administracion/EditarReporteria", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

           
                setTabla(modeloDatos);
                setVerModal(!verModal);
          
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.reporteID,
            sortable: true,
        },
        {
            name: 'Modulo ',
            selector: row => row.nombreModulo,
            sortable: true,
        },
          {
            name: 'Boton ',
            selector: row => row.nombreBoton,
            sortable: true,
        },

        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Lista de Reportes
                    <a className="btn" color="primary"
                        onClick={() => Setinterativo(true)} >
                        <i >Guia</i>
                    </a>
                </CardHeader>
                <CardBody>
                    <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nuevo Reporte</Button>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal className="modal-preguntas" isOpen={verModal}>
                <ModalHeader className="modal-header1">

                    <div class="box">
                        <div>   Movimiento Reportes </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm={4}>
                            <FormGroup>
                                <Label>Modulo</Label>
                            <Input bsSize="sm" type={"select"} name="moduloID" onChange={handleChange} value={tabla.moduloID} className="form-control">
                                    {L_Modulos.map(x => (
                                        <option value={x.moduloID}>{ x.descripcion}</option> 
                                        ))}
                                    
                               

                            </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={4}>
                            <FormGroup>
                                <Label>Nombre Modulo </Label>
                                <Input bsSize="sm" name="nombreModulo" onChange={handleChange} value={tabla.nombreModulo} />
                            </FormGroup>
                        </Col>
                    
                   
                        <Col sm={4}>
                            <FormGroup>
                                <Label>Nombre Boton</Label>
                                <Input bsSize="sm" name="nombreBoton" onChange={handleChange} value={tabla.nombreBoton} />

                            </FormGroup>
                        </Col>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Codigo HTML</Label>
                                <Input type="textarea" rows="6"  name="htmLcode" onChange={handleChange} value={tabla.htmLcode} />

                            </FormGroup>
                        </Col>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Codigo SCRIPT</Label>
                                <Input type="textarea" rows="6" name="scriptcode" onChange={handleChange} value={tabla.scriptcode} />

                            </FormGroup>
                        </Col>

                       
                    </Row>

                    <Row>
                     

                          
                       
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <div > <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button></div>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*AYUDA TUTORIAL*/}
            <Modal className="modal-preguntas" isOpen={interativo}>
                <ModalHeader className="modal-header1">
                    Manuales interativo.
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {/*<a href="\imagen\Manual de usuario Sistema Evaluación de Desempeño ETED.pdf" target="_blank" >Descargar Manual PDF</a>*/}
                            <video width="100%" height="70%" controls>
                                <source src="\imagen\Secuencia.mp4" type="video/mp4" />
                            </video>

                            <Button size="sm" color="danger"
                                onClick={() => Setinterativo(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>

        </>
    )

}
export default SecuenciaNumerica;